import React, { useEffect, useMemo, useState } from "react";
import styles from "./topnav.module.scss";
import ZentraLogo from "../../assets/icons/ZentraLogo";
import { Breadcrumb, Flex, Dropdown, Menu } from "antd";
import { PlusOutlined, DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../common/CustomButton";
import { setNavNewReportBtn } from "../../store/reducers/slices/topnav.slice";
import ProfilePicture from "../ProfilePopover";
import ProfileIcon from "../../assets/icons/ProfileIcon";
import authorization from "../../utils/auth/authorization";
import { downloadReport } from "../../api/homepage";
import { accountTypes } from "../../utils/ConstantData";
import { setSelectedAccount } from "../../store/reducers/slices/reportDetails.slice";
import { setReportAnalysisProgress } from "../../store/reducers/slices/createReport.slice";
import { setExtractedData } from "../../store/reducers/slices/extractedData.slice";
import { setUploadedAccountDetails } from "../../store/reducers/slices/updateReport.slice";
import { setAllOverviewData } from "../../store/reducers/slices/overview.slice";


const TopNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const user = authorization.getAuthUser();
    const [hovered, setHovered] = useState(false);

    const { breadcrumb, showNewReport, showDownload, showDelete } = useSelector((state) => state.topnav);
    const { selectedAccountId, reportDetails } = useSelector(({ reportDetails }) => reportDetails);
    const [activeBreadcrumb, setActiveBreadcrumb] = useState(null); // State to track active breadcrumb

    const [selectedAccount, setSelectedAccount] = useState(null);

    const [isSecondClicked, setSecondClicked] = useState(false);

    const handleNewReport = () => {
        dispatch(setExtractedData(null))
        dispatch(setUploadedAccountDetails(null));
        navigate("/reports/new-report");
    };

    useEffect(() => {
        if (location.pathname === "/reports/new-report") {
            dispatch(setNavNewReportBtn(false));
        } else {
            dispatch(setNavNewReportBtn(true));
        }
    }, [dispatch, location.pathname]);

    const handleLogout = () => {
        authorization.logout();
        dispatch({ type: "auth/logout" });
        navigate("/");
    };

    const handleDownloadReport = async (key) => {
        console.log('reporrtttt', key)
        console.log("reportDetails", reportDetails)
        const reportId = reportDetails.report?.reportId;
        const accountId = key !== "all" ? key : "all";

        await downloadReport(accountId, reportId, reportDetails);
    };

    const accountListOption = useMemo(() => {
        let list = [];
        if (reportDetails.reportAccounts && reportDetails.reportAccounts.length > 0) {
            list = reportDetails.reportAccounts.map((item) => {
                let accountElement = item.account || item.aaConsentDetails;
                let accountTypeObj =
                    item.account &&
                    accountTypes.find(
                        ele =>
                            ele.name.toUpperCase() ===
                            item.account.accountTypeName.toUpperCase()
                    );

                return {
                    key: accountElement.accountId,
                    label: `${accountElement.bank ? accountElement.bank.name : accountElement.bankName} - ${accountElement.accountNumber || accountElement.accountReferenceNumber} ${accountTypeObj && accountTypeObj.id === 3
                        ? " - OD / CC"
                        : accountTypeObj
                            ? " - " + accountTypeObj.title
                            : accountElement.accountTypeName
                                ? " - " + accountElement.accountTypeName
                                : ""
                        }`
                };
            });
        }
        const allBankNamesSame = reportDetails?.reportAccounts?.every((account, _, arr) => account.account.bankName === arr[0].account.bankName);

        if (list.length > 1 && reportDetails?.report?.precisaScore && allBankNamesSame === true) {
            list.unshift({ key: 'all', label: 'All Bank Accounts' });
        }
        return list;
    }, [reportDetails]);

    const handleBreadcrumbNavigate = () => {
        dispatch(setAllOverviewData({
            overview: {},
        }));
        navigate("/reports");
    }

    const accountMenu = (
        <Menu
            onClick={(e) => handleDownloadReport(e.key)}
            items={accountListOption}
        />
    );

    const isReportPage = location.pathname.startsWith("/reports/") &&
        location.pathname !== "/reports/new-report" &&
        location.pathname.split("/").length === 3;

    return (
        <div className={styles.topnav}>
            <div className={styles.logo} style={{ cursor: "pointer" }}>
                <div onClick={handleBreadcrumbNavigate}>
                    <ZentraLogo />
                </div>

                {breadcrumb && breadcrumb.length > 1 && (



                    <div className={styles.titleWrapper}
                        style={{ cursor: "pointer" }}>
                        {/* 
                        <Breadcrumb >

                            <Breadcrumb.Item onClick={handleBreadcrumbNavigate}
                            > {breadcrumb[0].title} </Breadcrumb.Item>
                            <Breadcrumb.Item style={{

                            }}> {breadcrumb[1]?.title} </Breadcrumb.Item>
                        </Breadcrumb> */}
                        <Breadcrumb>
                            <Breadcrumb.Item
                                onClick={handleBreadcrumbNavigate}
                                className={styles.breadcrumb}
                            >
                                {breadcrumb[0].title}
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                {breadcrumb[1]?.title}
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                )}
            </div>
            <Flex gap={8}>
                {isReportPage && (
                    <>
                        <Dropdown overlay={accountMenu} trigger={["click"]}>
                            <CustomButton icon={<DownloadOutlined />}>
                                Download Analysis
                            </CustomButton>
                        </Dropdown>
                        {/* <CustomButton icon={<DeleteOutlined />}>
                            Delete
                        </CustomButton> */}
                    </>
                )}
                {showNewReport && (
                    <CustomButton icon={<PlusOutlined />} type="primary" onClick={handleNewReport}>
                        Add Customer
                    </CustomButton>
                )}
                <ProfilePicture
                    imageUrl={<ProfileIcon />}
                    username={`${user?.firstName} ${user?.lastName}`}
                    role={user?.role}
                    onLogout={handleLogout}
                />

            </Flex>
        </div>
    );
};

export default TopNav;
